module.exports = __webpack_public_path__ + "img/2015_davao.968c8b5c.jpg";